export default "__VITE_ASSET__CXlTBXzo__$_?nuxt_component=async&nuxt_component_name=SvgoHomeCryptoinfrastrIcon&nuxt_component_export=default__"